module.exports = __webpack_public_path__ + "static/hcm-mobile-screen2-cb3a160c63f25e010d3ebd129c033865.jpeg";